module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Loader-591f2ecf3f0186968aaa74dd1d0ed12b.svg";